import BranchDropdown from 'components/functional-buttons/BranchDropdown';
import DinamicRouteTabs from '../../../components/custom/template/dinamicRouteTabs';
import EmployeeLatePunchinHistory from './EmployeeLatePunchinHistory';
import EmployeeLatePunchinApprovalPending from './EmployeeLatePunchinApprovalPending';
import { approvalPaths } from 'constants/pagePath';

const tabs = [
  {
    id: 'pending',
    label: 'Approval Pending',
    icon: 'mdi:bell-alert-outline',
    path: approvalPaths.latePunchin.pending,
    content: <EmployeeLatePunchinApprovalPending />
  },
  {
    id: 'history',
    label: 'Approval History',
    icon: 'mdi:clipboard-list-outline',
    path: approvalPaths.latePunchin.history,
    content: <EmployeeLatePunchinHistory />
  }
];

const EmployeeLatePunchinApproval = () => {
  return (
    <div>
      <div className="gap-2 d-flex mb-0 justify-content-between flex-column flex-sm-row ">
        <div>
          <h2 className="mb-5 font-outfit fw-medium">Employee Late Punch-In</h2>
        </div>

        <div className="gap-1 d-flex mb-4 justify-content-between flex-column flex-sm-row">
          <div>
            <BranchDropdown />
          </div>
        </div>
      </div>
      <DinamicRouteTabs tabs={tabs} />
    </div>
  );
};

export default EmployeeLatePunchinApproval;
